import type { ProductFilterOption } from '@/types/productRegistry';

export const productStatusFilterOptions: ProductFilterOption[] = [
  { value: 'all', labelKey: 'productRegistry.productRegistryFilters.statusAll' },
  { value: 'active', labelKey: 'productRegistry.productRegistryFilters.statusActive' },
  { value: 'inactive', labelKey: 'productRegistry.productRegistryFilters.statusInactive' },
  { value: 'maintenance', labelKey: 'productRegistry.productRegistryFilters.statusMaintenance' },
  { value: 'deprecated', labelKey: 'productRegistry.productRegistryFilters.statusDeprecated' },
];

export const productCategoryFilterOptions: ProductFilterOption[] = [
  { value: 'all', labelKey: 'productRegistry.productRegistryFilters.categoryAll' },
  { value: 'underwriting', labelKey: 'productRegistry.productRegistryCategories.underwriting' },
  { value: 'monitoring', labelKey: 'productRegistry.productRegistryCategories.monitoring' },
  { value: 'compliance', labelKey: 'productRegistry.productRegistryCategories.compliance' },
  { value: 'database', labelKey: 'productRegistry.productRegistryCategories.database' },
  { value: 'identity', labelKey: 'productRegistry.productRegistryCategories.identity' },
];

export const productRegistryPageSizes = [10, 25, 50, 100] as const;

export const defaultProductRegistryPageSize = 25;

export const productActionDefinitions = [
  { id: 'edit', labelKey: 'productRegistry.productRegistryActions.edit', permission: 'PRODUCT_EDIT' },
  {
    id: 'configureNavigation',
    labelKey: 'productRegistry.productRegistryActions.configureNavigation',
    permission: 'PRODUCT_EDIT',
  },
  {
    id: 'assignRoles',
    labelKey: 'productRegistry.productRegistryActions.assignRoles',
    permission: 'PRODUCT_ASSIGN_ROLE',
  },
  {
    id: 'manageFeatureFlags',
    labelKey: 'productRegistry.productRegistryActions.manageFeatureFlags',
    permission: 'PRODUCT_EDIT',
  },
  {
    id: 'viewAuditHistory',
    labelKey: 'productRegistry.productRegistryActions.viewAuditHistory',
    permission: 'PRODUCT_VIEW',
  },
  {
    id: 'openEmbeddedApp',
    labelKey: 'productRegistry.productRegistryActions.openEmbeddedApp',
    permission: 'PRODUCT_VIEW',
  },
  {
    id: 'deactivate',
    labelKey: 'productRegistry.productRegistryActions.deactivate',
    permission: 'PRODUCT_DEPLOY',
  },
  {
    id: 'delete',
    labelKey: 'productRegistry.productRegistryActions.delete',
    permission: 'PRODUCT_DELETE',
    destructive: true,
  },
] as const;

export const productBulkActionDefinitions = [
  { id: 'activate', labelKey: 'productRegistry.productRegistryBulkActions.activate', permission: 'PRODUCT_DEPLOY' },
  {
    id: 'deactivate',
    labelKey: 'productRegistry.productRegistryBulkActions.deactivate',
    permission: 'PRODUCT_DEPLOY',
  },
  { id: 'delete', labelKey: 'productRegistry.productRegistryBulkActions.delete', permission: 'PRODUCT_DELETE' },
  {
    id: 'assignCategory',
    labelKey: 'productRegistry.productRegistryBulkActions.assignCategory',
    permission: 'PRODUCT_EDIT',
  },
  {
    id: 'moveEnvironment',
    labelKey: 'productRegistry.productRegistryBulkActions.moveEnvironment',
    permission: 'PRODUCT_DEPLOY',
  },
  { id: 'export', labelKey: 'productRegistry.productRegistryBulkActions.export', permission: 'PRODUCT_VIEW' },
] as const;
